enum RuuviTagType {
  DEVICE = 'ruuvi_tag',
  VALVE_IN = 'valve_in',
  VALVE_OUT = 'valve_out',
  ATTACHED = 'attached'
}

export default RuuviTagType
